import { Box, styled } from '@mui/material';

const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: end;
  gap: 1rem;

  margin-bottom: 1rem;
`;

export default ButtonWrapper;
